import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { AiManagementColumn } from 'store/modules/ai_management_store/types';
import AiManagementModalHeader from 'components/molecules/ai_management_modal_header';
import { Container } from './styles';

export interface DeleteColumnChoice {
  targetColumnId?: number;
  archiveCards?: boolean;
}

interface AiManagementDeleteColumnModalProps {
  column: AiManagementColumn | null;
  columns: AiManagementColumn[];
  show: boolean;
  onClose: () => void;
  onConfirm: (choice: DeleteColumnChoice) => void;
}

const AiManagementDeleteColumnModal: React.FC<AiManagementDeleteColumnModalProps> = ({
  column,
  columns,
  show,
  onClose,
  onConfirm,
}) => {
  const [step, setStep] = useState<'choice' | 'transfer'>('choice');
  const [targetId, setTargetId] = useState<number | null>(null);

  const targets = columns.filter(
    (candidate) => candidate.id !== column?.id && candidate.permissions.accepts_cards,
  );

  useEffect(() => {
    if (!show) return;
    setStep('choice');
    setTargetId(targets[0]?.id ?? null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, column]);

  if (!column) return null;

  const confirmTransfer = () => {
    if (!targetId) return;
    onConfirm({ targetColumnId: targetId });
  };

  return (
    <Modal show={show} onHide={onClose} centered style={{ zIndex: 3000000005 }}>
      <Container>
        <AiManagementModalHeader title="Excluir coluna" onClose={onClose} />

        {column.cards_count === 0 && (
          <>
            <div className="delete-body px-4 pt-4">
              Deseja excluir a coluna &quot;{column.name}&quot;?
            </div>
            <div className="d-flex px-4 py-4">
              <button type="button" className="btn btn-outline-secondary mr-2" onClick={onClose}>
                Cancelar
              </button>
              <button type="button" className="btn btn-danger" onClick={() => onConfirm({})}>
                Excluir coluna
              </button>
            </div>
          </>
        )}

        {column.cards_count > 0 && step === 'choice' && (
          <div className="delete-body px-4 pt-4 pb-4">
            <p>
              Essa coluna possui licitações. Você pode transferí-las para outra coluna ou
              arquivá-las.
            </p>
            <p className="mb-3">O que deseja fazer?</p>
            <div className="d-flex flex-wrap">
              <button
                type="button"
                className="btn btn-outline-primary mr-2 mb-2"
                onClick={() => setStep('transfer')}
                disabled={targets.length === 0}
              >
                Transferir licitações
              </button>
              <button
                type="button"
                className="btn btn-outline-primary mb-2"
                onClick={() => onConfirm({ archiveCards: true })}
              >
                Arquivar licitação
              </button>
            </div>
            {targets.length === 0 && (
              <div className="text-muted small">
                Não há outra coluna disponível para receber as licitações.
              </div>
            )}
          </div>
        )}

        {column.cards_count > 0 && step === 'transfer' && (
          <>
            <div className="delete-body px-4 pt-4">
              <p className="mb-3">Escolha para qual coluna deseja transferir as licitações:</p>
              {targets.map((candidate) => (
                <div key={candidate.id} className="form-check mb-2">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="delete-column-target"
                    id={`delete-column-target-${candidate.id}`}
                    checked={targetId === candidate.id}
                    onChange={() => setTargetId(candidate.id)}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`delete-column-target-${candidate.id}`}
                  >
                    {candidate.name}
                  </label>
                </div>
              ))}
            </div>

            <div className="d-flex px-4 py-4">
              <button type="button" className="btn btn-outline-secondary mr-2" onClick={onClose}>
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={confirmTransfer}
                disabled={!targetId}
              >
                Transferir licitações
              </button>
            </div>
          </>
        )}
      </Container>
    </Modal>
  );
};

export default AiManagementDeleteColumnModal;
